module.exports = __webpack_public_path__ + "static/media/vencimiento_amarillo.58d95c91.svg";